import { LitElement, html, customElement, css, query, property, internalProperty } from "lit-element";
import { spread } from "@open-wc/lit-helpers";
import GLB from '../assets/models/STROMMAST_LOWPOLY_SCALE_1_OHNE_NETZ_V17.glb';
import USDZ from '../assets/models/STROMMAST_LOWPOLY_SCALE_1_OHNE_NETZ_V17.usdz';
@customElement("cteam-ar-viewer")
export class OcArViewer extends LitElement {

    @property() model = "";
    @property() base = "https://github.io/objectocde..."
    @internalProperty() glbURL = "";
    @internalProperty() usdzURL = "";
    @internalProperty() attributeMap = {};

    @query("#ar-button")
    arButton!: HTMLButtonElement;

    isLocal = false;

    constructor() {
        super();
        this.pipelineAttributes();
        // Pipeline all Attributes.. Espacially when changed. This is the official way :)
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                if (mutation.type == "attributes") {
                    this.pipelineAttributes();
                }
            });
        });

        observer.observe(this, {
            attributes: true, //configure it to listen to attribute changes
        });

        this.isLocal = Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
            ) ||
            window.location.hostname === "0.0.0.0"
        );
    }

    pipelineAttributes() {
        const newAttributeMap: { [key: string]: string } = {};
        Array.from(this.attributes).forEach((attribute) => {
            newAttributeMap[attribute.name] = attribute.value;
        });
        this.attributeMap = newAttributeMap;
    }


    static get styles() {
        return css`
            #ar-button {
                position: absolute;
                bottom: 0px;
                right: 0px;
                margin: 40px;
                border: none;
                padding: 0px;
                outline: none;
            }
        `;
    }

    render() {
        return html`
        <oc-ar-viewer
        src="${(this.isLocal ? location.href : "https://dev.objectcode.de/cteam/") + GLB}"
        ios-src="${(this.isLocal ? location.href : "https://dev.objectcode.de/cteam/") + USDZ}"
        heading="Augmented-Reality"
        ...=${spread(this.attributeMap)}
        >
            <slot name="ar-button" slot="ar-button">
                <button id="ar-button" slot="ar-button">
                <img
                    style=${"cursor: pointer;"}
                    src="https://developer.apple.com/design/human-interface-guidelines/ios/images/ARKit_Glyph_Button.svg"
                    width="250"
                />
                </button>
            </slot>
        </oc-ar-viewer>
        `;
    }
}
